import { render, staticRenderFns } from "./clueDetails.vue?vue&type=template&id=ccdfe02c&scoped=true"
import script from "./clueDetails.vue?vue&type=script&lang=js"
export * from "./clueDetails.vue?vue&type=script&lang=js"
import style0 from "./clueDetails.vue?vue&type=style&index=0&id=ccdfe02c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdfe02c",
  null
  
)

export default component.exports